import Vue from "vue";
import axios from 'axios';

// var ua = navigator.userAgent;
//
// function isWeixinBrowser(uaToLowerCase) {
//     return (/micromessenger/.test(uaToLowerCase)) ? true : false;
// }
// function isApp(ua) {
//     return ua.indexOf('web_ua')>-1?true:false;
// }
// var isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
//
// if (ua.indexOf('web_ua')>-1){
//     var ua_data = JSON.parse(ua.match(/web_ua=(\S*)/)[1]);
//     axios.defaults.headers.common['Authorization'] = 'Bearer ' + ua_data.token
// }else if(isWeixinBrowser(ua.toLowerCase())){
//     axios.defaults.headers.common['Authorization'] = 'Bearer ' +getStore('token')
// }else if(ua.indexOf('ios_app')>-1){
//     axios.defaults.headers.common['Authorization'] = ua.match(/&([\s\S]*)/)[1];
// }else {
//     //axios.defaults.headers.common['Authorization'] = 'Bearer ' + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xOTIuMTQ0LjE1Ni4xNjdcL2ludGVyZmFjZS5waHBcL2xvZ2luIiwiaWF0IjoxNTc3NDQ2MzIxLCJleHAiOjE1ODAwMzgzMjEsIm5iZiI6MTU3NzQ0NjMyMSwianRpIjoiZnkwWWkzN0s0TXpKd0lQaiIsInN1YiI6NCwicHJ2IjoiZjZiNzE1NDlkYjhjMmM0MmI3NTgyN2FhNDRmMDJiN2VlNTI5ZDI0ZCJ9.utc35Zfrp6N9LL-t1dSgGVfJu57mOOO6naduAtPVPdk';
//     //axios.defaults.headers.common['Authorization'] = 'Bearer ' + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xOTIuMTQ0LjE1Ni4xNjdcL2ludGVyZmFjZS5waHBcL2xvZ2luIiwiaWF0IjoxNTc4MzkzNDg4LCJleHAiOjE1ODA5ODU0ODgsIm5iZiI6MTU3ODM5MzQ4OCwianRpIjoid1Y4cVp1RGVtV3JpRHlVUCIsInN1YiI6MywicHJ2IjoiZjZiNzE1NDlkYjhjMmM0MmI3NTgyN2FhNDRmMDJiN2VlNTI5ZDI0ZCJ9.1hwA5yUOL461HU7lHXdgALHOiEFIGuP4V_ChwcPdurU';
//     axios.defaults.headers.common['Authorization'] = 'Bearer ' +getStore('token')
//
// }

axios.defaults.baseURL = 'https://xy.instqr.com/qiubi/api/v1/';
// axios.defaults.baseURL = 'https://qbdzcd.bjszhd.cn/qiubi/api/v1/';



// Add a response interceptor
// axios.interceptors.response.use(
//     function(response) {
//         // Do something with response data
//
//
//         if (isWeixinBrowser(ua.toLowerCase())){
//             if(response.data.code===498){
//                 window.location.href="/#/share/login";
//             }
//         }else if(ua.indexOf('web_ua')>-1 ||ua.indexOf('ios_app')>-1){
//             if (window.location!= "/relogin" && response.data.code===498 ){
//                 //window.location.href="/relogin?url="+encodeURIComponent(window.location.href);
//                 window.location.href="/#/relogin";
//             }
//         }else {
//             if (window.location!= "/share/login" && response.data.code===498 ){
//                 //window.location.href="/relogin?url="+encodeURIComponent(window.location.href);
//                 window.location.href="/#/share/login";
//             }
//         }
//
//         return response;
//     },
//     function(error) {
//         // Do something with response error
//         return Promise.reject(error);
//     }
// );
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
    var _this = Vue.prototype;
    // if (_this.$xiaozhu.sess.user) {//每次请求都带的参数放这里
    //   params.userId = _this.$xiaozhu.sess.user.userid;
    //   params.sessId = _this.$xiaozhu.sess.user.sessid;
    // }
    //params.timestamp = new Date().getTime();
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装post_file请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post_file(url, formData = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}


/**
 * 封装delete请求
 * @param url
 * @param key
 * @param value
 * @returns {Promise}
 */

export function dele(url, key ,value) {
    var _this = Vue.prototype;
    // if (_this.$xiaozhu.sess.user) {//每次请求都带的参数放这里
    //   params.userId = _this.$xiaozhu.sess.user.userid;
    //   params.sessId = _this.$xiaozhu.sess.user.sessid;
    // }
    //params.timestamp = new Date().getTime();
    return new Promise((resolve, reject) => {
        axios.delete(url+'?'+key+'='+value)
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function getParam(paramName) {
    var myUrl = decodeURI(window.document.URL);
    var sURL = myUrl.toString().replace(/#/, '&');
    if (sURL.indexOf("?") > 0) {
        var arrParams = sURL.split("?");
        var arrURLParams = arrParams[1].split("&");
        var arrParamNames = new Array(arrURLParams.length);
        var arrParamValues = new Array(arrURLParams.length);
        for (var i = 0; i < arrURLParams.length; i++) {
            var sParam = arrURLParams[i].split("=");
            arrParamNames[i] = sParam[0];
            if (sParam[1] != "") {
                arrParamValues[i] = unescape(sParam[1]);
            } else {
                arrParamValues[i] = "";
            }
        }
        for (i = 0; i < arrURLParams.length; i++) {
            if (arrParamNames[i] == paramName) {
                return arrParamValues[i] == 'undefined' ? '' : decodeURIComponent(arrParamValues[i]);
            }
        }
        return '';
    }
    return '';
}

//获取地址栏参数
function getParamCommon(paramName, url) {
    if (!url) {
        return
    }
    var sURL = url.replace(/#/, '&');
    if (sURL.indexOf("?") > 0) {
        var arrParams = sURL.split("?");
        var arrURLParams = arrParams[1].split("&");
        var arrParamNames = new Array(arrURLParams.length);
        var arrParamValues = new Array(arrURLParams.length);
        for (var i = 0; i < arrURLParams.length; i++) {
            var sParam = arrURLParams[i].split("=");
            arrParamNames[i] = sParam[0];
            if (sParam[1] != "") {
                arrParamValues[i] = unescape(sParam[1]);
            } else {
                arrParamValues[i] = "";
            }
        }
        for (i = 0; i < arrURLParams.length; i++) {
            if (arrParamNames[i] == paramName) {
                return arrParamValues[i] == 'undefined' ? '' : arrParamValues[i];
            }
        }
        return '';
    }
    return '';
}

//本地存储信息
export function setStore(key, val) {
    if (typeof (val) == 'object') {
        localStorage.setItem(key, JSON.stringify(val))
    } else {
        localStorage.setItem(key, val)
    }
}
//获取本地存储信息
export function getStore(key) {
    let val = localStorage.getItem(key)
    if (!val) {
        return null;
    } else if (val.indexOf('{') == 0 || val.indexOf('[') == 0) {
        return JSON.parse(val);
    } else {
        return val;
    }
}
